
      let deferredPrompt = null;
      const installBtn = document.querySelector('.pwa-install-btn');
      const pwaBanner = document.querySelector('.pwa-install');
      const closeBtn = document.querySelector('.pwa-close-btn');

      // Log for debugging
      console.log('PWA script loaded');

      // Register service worker
      if ('serviceWorker' in navigator) {
        window.addEventListener('load', async () => {
          try {
            const registration = await navigator.serviceWorker.register('/sw.js');
            console.log('Service Worker registered:', registration);
          } catch (error) {
            console.error('Service Worker registration failed:', error);
          }
        });
      } else {
        console.warn('Service Worker not supported');
      }

      // Handle beforeinstallprompt event
      window.addEventListener('beforeinstallprompt', (e) => {
        console.log('beforeinstallprompt event fired');
        e.preventDefault();
        deferredPrompt = e;
        pwaBanner.classList.add('visible');
      });

      // Install button click handler
      installBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        if (!deferredPrompt) {
          console.warn('No deferred prompt available');
          return;
        }
        pwaBanner.classList.remove('visible');
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        console.log(`PWA prompt outcome: ${outcome}`);
        deferredPrompt = null;
      });

      // Close button handler
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        pwaBanner.classList.remove('visible');
        console.log('PWA banner closed');
      });

      // Show banner for testing if URL contains 'pwa'
      if (window.location.href.includes('pwa')) {
        console.log('Showing PWA banner for testing (URL contains "pwa")');
        pwaBanner.classList.add('visible');
      }

      // Handle app installation
      window.addEventListener('appinstalled', () => {
        console.log('PWA installed successfully');
        pwaBanner.classList.remove('visible');
        deferredPrompt = null;
      });
    